import React, { Component } from "react";
import ImageOrInitial from "./ImageOrInitial";
import Popup from 'reactjs-popup';
import FilterBar from "./FilterBar";
class Selector extends Component {
  constructor(props) {
    super(props);
    this.state = {
      popupOpen:false,
      activeAccounts:[],
    };
  }

  onChange = (account) =>{

    this.props.onChange(account);

    if(this.props.onChange){
      this.props.onChange(account);
    }

    this.setState({popupOpen:false});
  }

  onPopupOpen = () =>{
    this.setState({popupOpen:true});
    this.updateFilter();

    console.log(this.props.defaultValue);
  }

  updateFilter = (e) =>{

    if(e?.target.value){
      /****TODO can refine this */
      var activeAccounts = this.props.options.filter(account => account.name.toLowerCase().indexOf(e.target.value.toLowerCase()) > -1);
      this.setState({activeAccounts:activeAccounts.length > 6 ? activeAccounts.slice(0, 6) : activeAccounts});
    }
    else{
      this.setState({activeAccounts:this.props.options.length > 6 ? this.props.options.slice(0, 6) : this.state.accounts});
    }

  }


  render() {
    var _defaultValue = null;;
    if(this.props.defaultValue){
      _defaultValue = this.props.defaultValue.name || this.props.defaultValue;
    }

    return (
      <>
      <a onClick={this.onPopupOpen} className="fieldInput filterSelector">{_defaultValue || this.props.placeholderText}
      {this.props.defaultValue &&
      <ImageOrInitial image={this.props.defaultValue.imageUrl} className="fieldInputLogo" name={this.props.defaultValue.name} />
      }
      </a> 

      <Popup className='filterSelectorPopup' closeOnDocumentClick={false} open={this.state.popupOpen} position="center center">
        <FilterBar onUpdate={this.updateFilter} placeholderText={this.props.searchPlaceholderText}/>
        <div className="card fullTable filterSelectorTable">
        {this.state.activeAccounts?.map((account, index) => {
            return <a key={"account_"+account.companyId} className="tableRow" onClick={() =>this.onChange(account)}>
              <ImageOrInitial image={account.imageUrl} className="searchItemLogo" name={account.name} />
              <div  className="searchItemName">{account.name}</div>
            </a>

        })}
        </div>
        <button className="pillButton"  onClick={() => this.setState({popupOpen:false})}>Cancel</button>
      </Popup>  
    </>
    );
  }
}
 
export default Selector;